import { Stack, Box, Typography } from '@mui/material';
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { Tooltip } from 'framework/ui/mui-builder';

const ProjectTeamIssuesField = (props: FieldProps<string[]>) => {
  const { getValue } = useFieldHelper<string[]>(props);
  const issues = getValue() || [];

  return (
    <Tooltip
      title={
        <Box sx={{ whiteSpace: 'pre-line' }}>
          {issues.map(item => {
            return <Typography variant="body1">{item || ''}</Typography>;
          })}
        </Box>
      }
      placement="top"
      disableHoverListener={issues.length === 1}
      arrow
    >
      <Stack>
        <Typography variant="body1" color="error">
          {issues[0] || ''}
        </Typography>
        {issues.length > 1 && (
          <Typography variant="body1" color="error">{`...and ${issues.length - 1} more`}</Typography>
        )}
      </Stack>
    </Tooltip>
  );
};

export default ProjectTeamIssuesField;
